import { Helmet } from "react-helmet-async";

import Logo from "@/assets/images/logo.png";
import Router from "@/router/index";

import { MotionLazy } from "./components/animate/motion-lazy";
import Toast from "./components/toast";
import { AntdAdapter } from "./theme/adapter/antd.adapter";
import { ThemeProvider } from "./theme/theme-provider";
import { useEffect } from "react";
import useUserStore from "./store/userStore";
import logo1 from "@/assets/images/onlylogovantageai.png";

function App() {
	const { refreshCredits } = useUserStore.getState().actions;

	useEffect(() => {
		if (window.location.pathname.includes('undefined')) {
			const cleanPath = window.location.pathname.replace('/undefined', '') || '/';
			window.history.replaceState(null, '', cleanPath + window.location.search + window.location.hash);
		}
		refreshCredits();
	}, [refreshCredits]);

	return (
		<ThemeProvider adapters={[AntdAdapter]}>
			<MotionLazy>
				<Helmet>
					<title>VantageAI</title>
					<link rel="icon" href={logo1} />
				</Helmet>
				<Toast />

				<Router />
			</MotionLazy>
		</ThemeProvider>
	);
}

export default App;
